import { render, staticRenderFns } from "./ExpeditionForm.vue?vue&type=template&id=9c16e020"
import script from "./ExpeditionForm.vue?vue&type=script&lang=js"
export * from "./ExpeditionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports